import { PropsWithClassName } from "../../common/types/PropsWithClassName";
import { useAppSelector } from "../../common/hooks/useStore";
import { selectLocationById } from "./locationsSlice";

interface LocationLabelProps extends PropsWithClassName {
  value?: string;
}

export default function LocationLabel({ className, value }: LocationLabelProps) {
  const location = useAppSelector((state) => (value ? selectLocationById(state, value) : undefined));

  return <div className={className}>{location?.name}</div>;
}
